import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { clearActionNotification } from 'redux/common/actions';

import './CommonActionNotification.css';

class CommonActionNotification extends Component {
  static propTypes = {
    clearActionNotification: PropTypes.func.isRequired,
    actionSuccessNotification: PropTypes.bool,
  };

  static defaultProps = {
    actionSuccessNotification: null,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.actionSuccessNotification && this.props.actionSuccessNotification) {
      setTimeout(() => {
        this.props.clearActionNotification();
      }, 800);
    }
  }

  render() {
    if (!this.props.actionSuccessNotification) return null;

    return (
      <div className="common-action-notification__component">
        <div className="success-checkmark">
          <div className="check-icon">
            <span className="icon-line line-tip" />
            <span className="icon-line line-long" />
            <div className="icon-fix" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    actionSuccessNotification: state.commonReducer.actionSuccessNotification,
  }
);

export default connect(
  mapStateToProps,
  {
    clearActionNotification,
  },
)(CommonActionNotification);
